import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityMessage } from "../../entity/EntityMessage";

export class DtoMessagesPostReq extends EntityMessage {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
